import I18n from "../../i18n";
import ComponentBase from "./componentBase";

export default abstract class FlagOptionBase extends ComponentBase{

    constructor(
        protected parent:HTMLElement,
        protected idOption:string,
        protected elementoToRender:string
    ){
        super(parent,idOption,elementoToRender);
    }

    abstract translateAction():void;

    public loadFlag():HTMLElement{
        return this.renderWithCB(()=>{
            this.elementRendered.addEventListener("click",()=>{
                this.translateAction();
                I18n.exec();
            });
        });
    }
}